
import { Vue, Component } from 'vue-property-decorator';
import { unionIdIsBind } from '@/api/api';
import { isWeiXin } from '@/common/ts/common';
import { Toast } from 'vant';
import qs from 'qs';
import {
  luckDraw,
  fillAddress,
  getPrizeList,
  getPrizeDetail,
} from '../api';
import banner from '../assets/banner.png';
import titleLucky from '../assets/title-lucky.png';
import giftLucky from '../assets/gift-lucky.png';
import btnLottery from '../assets/btn-lottery.png';
import titleCoupon from '../assets/title-coupon.png';
import giftCoupon from '../assets/gift-coupon.png';
import splashGif from '../assets/splash.gif';
import {
  prizes,
  prizeNames,
  couponGroups,
  PrizeItem,
  PrizeRecord,
  readWorkType,
  isPhysicalPrize,
} from '../data';
import {
  BindPhonePopup,
  LotteryResultPopup,
  AddressPopup,
  MyPrizePopup,
  SplashGif,
} from '../components';

const PHONE_KEY = 'QNCQTDYDHG_phone';
// 中奖列表每页条数（与接口保持一致，用于判断是否还有下一页）
const PRIZE_PAGE_SIZE = 10;

interface LotteryResult {
  win: boolean;
  image: string;
  text: string;
  name: string;
  needAddress: boolean;
  // 奖品类型：2 积分，3 实物
  workType: number;
}

// 实物奖品收货信息
interface AddressInfo {
  name: string;
  address: string;
}

@Component({
  components: {
    BindPhonePopup,
    LotteryResultPopup,
    AddressPopup,
    MyPrizePopup,
    SplashGif,
  },
})
export default class Home extends Vue {
  banner = banner;
  titleLucky = titleLucky;
  giftLucky = giftLucky;
  btnLottery = btnLottery;
  titleCoupon = titleCoupon;
  giftCoupon = giftCoupon;
  splashGif = splashGif;
  // 开屏 GIF 是否展示
  showSplash = true;
  prizes: PrizeItem[] = prizes;
  prizeNames: string[] = prizeNames;
  couponGroups: string[][] = couponGroups;
  couponIndex = 0;
  couponSwiperOptions = {
    slidesPerView: 1,
    speed: 400,
    autoHeight: true,
  };
  // 自动切换定时器
  private couponTimer: number | null = null;

  // 弹窗状态
  bindVisible = false;
  resultVisible = false;
  addressVisible = false;
  myPrizeVisible = false;
  phone = '';
  addressTitle = '';
  // 填写地址弹窗回填内容
  addressForm: AddressInfo = { name: '', address: '' };
  records: PrizeRecord[] = [];
  // 中奖记录分页：已加载到第几页、是否全部加载完
  private prizePage = 0;
  prizeFinished = false;
  // 列表加载状态（van-list 展示用，van-list 触发 load 前会先置为 true）
  prizeLoading = false;
  // 正在请求的页码，0 表示当前没有请求，防止同一页重复请求
  private prizeLoadingPage = 0;
  result: LotteryResult = {
    win: false,
    image: '',
    text: '',
    name: '',
    needAddress: false,
    workType: 0,
  };
  private editingRecord: PrizeRecord | null = null;
  // 是否正在抽奖，防止重复点击
  private drawing = false;
  // 当前中奖记录ID（提交收货地址用）
  private prizeId = 0;

  async created() {
    this.phone = localStorage.getItem(PHONE_KEY) || '';
    const bound = await this.checkWeiXinBind();
    if (!bound) return;
  }

  async checkWeiXinBind(): Promise<boolean> {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.WechatLogin();
      return false;
    }
    return await this.checkIsBind();
  }

  async checkIsBind(): Promise<boolean> {
    const data = {
      type: 2,
      key: window.localStorage.getItem('unionid'),
    };
    if (window.udid) {
      return this.AppLogin();
    } else if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res || !res.data) {
        this.$router.push(
          `/BindPhone?url=${encodeURIComponent(location.href)}`,
        );
        return false;
      }
      return true;
    }
    Toast('请在微信或上游新闻App中打开');
    return false;
  }

  AppLogin() {
    const token = window.token;
    if (token) return true;
    window.openApp('mUserLogin');
    window.handleMessage('{"action":"mUserLogin","data":""}');
    window.location.href = 'client:logout';
    return false;
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }

  YouhuiUrl() {
    location.href= 'https://s.c1ns.cn/myJ8u';
  }

  mounted() {
    // 仅 2 张分组，Swiper 的 loop 会自动失效，这里用定时器实现循环自动切换
    this.couponTimer = window.setInterval(() => {
      if (this.couponGroups.length < 2) return;
      this.goCoupon((this.couponIndex + 1) % this.couponGroups.length);
    }, 4000);
  }

  beforeDestroy() {
    if (this.couponTimer) window.clearInterval(this.couponTimer);
  }

  onCouponChange() {
    const ref = this.$refs.couponSwiper as any;
    const swiper = ref && ref.swiperInstance;
    this.couponIndex = swiper ? swiper.realIndex : 0;
  }

  goCoupon(index: number) {
    const ref = this.$refs.couponSwiper as any;
    const swiper = ref && ref.swiperInstance;
    if (swiper) swiper.slideTo(index);
  }

  async onLottery() {
    // 先判断是否绑定微信，未绑定则跳转授权/绑定
    const bound = await this.checkWeiXinBind();
    if (!bound) return;
    // if (!this.phone) {
    //   this.bindVisible = true;
    //   return;
    // }
    this.draw();
  }

  onBindConfirm(phone: string) {
    this.phone = phone;
    localStorage.setItem(PHONE_KEY, phone);
    this.bindVisible = false;
    this.draw();
  }

  // 抽奖：调用 luck-draw 接口
  private async draw() {
    if (this.drawing) return;
    this.drawing = true;
    // const loading = Toast.loading({
    //   duration: 0,
    //   message: '抽奖中...',
    //   forbidClick: true,
    // });
    try {
      const unionid = localStorage.getItem('unionid');
      const res: any = await luckDraw({ unionid, phone: this.phone });
      if (!res) return;
      if (res.code === 200) {
        const prize = res.data || {};
        // 保存中奖记录ID，用于填写收货地址
        this.prizeId = Number(prize.id) || 0;
        // 只有实物奖品（workType=3）才需要填写收货地址
        const physical = isPhysicalPrize(readWorkType(prize));
        this.result = {
          win: true,
          image: prize.prizeCover || this.matchPrizeImage(prize.name),
          text:
            prize.score > 0
              ? `恭喜您抽中客户端积分：${prize.score}分`
              : `恭喜您抽中${prize.name}`,
          name: prize.name || '',
          needAddress: physical && !!prize.need_address,
          workType: readWorkType(prize),
        };
        this.resultVisible = true;
        return;
      }
      // 205 未中奖展示未中奖弹窗，其余状态直接提示
      if (res.code === 205) {
        this.result = {
          win: false,
          image: '',
          text: '',
          name: '',
          needAddress: false,
          workType: 0,
        };
        this.resultVisible = true;
        return;
      }
      Toast(res.msg || '抽奖失败，请稍后再试');
    } catch (e) {
      Toast('网络异常，请稍后再试');
    } finally {
      this.drawing = false;
      // loading.clear();
    }
  }

  // 按奖品名称匹配本地奖品图片
  private matchPrizeImage(name: string): string {
    if (!name) return prizes[2].img;
    const hit = prizes.find(
      (item) => name.indexOf(item.name) > -1 || item.name.indexOf(name) > -1,
    );
    return hit ? hit.img : prizes[2].img;
  }

  async onResultConfirm(info: AddressInfo) {
    const { name, address } = info || ({} as AddressInfo);
    const needFill = this.result.win && this.result.needAddress;
    this.resultVisible = false;
    if (!this.result.win) return;
    const record: PrizeRecord = {
      date: this.formatDate(new Date()),
      name: this.result.name,
      workType: this.result.workType,
      needAddress: needFill,
      address: address || undefined,
    };
    this.records.unshift(record);
    // 抽中实物，提交收货信息
    if (needFill) {
      const ok = await this.submitAddress({ name, address });
      record.needAddress = !ok;
    }
  }

  // 提交实物收货信息（fill-address）
  private async submitAddress(
    info: AddressInfo,
    recordId?: number,
  ): Promise<boolean> {
    const id = recordId || this.prizeId;
    if (!id) {
      Toast('未获取到中奖记录，请刷新后重试');
      return false;
    }
    const unionid = localStorage.getItem('unionid');
    const res: any = await fillAddress({
      id,
      name: info.name,
      // 收货人手机号不再单独填写，沿用当前登录绑定的手机号
      phone: this.phone,
      address: info.address,
      unionid,
    });
    if (res && res.code === 200) {
      Toast('收货信息提交成功');
      return true;
    }
    Toast((res && res.msg) || '收货信息提交失败，请稍后再试');
    return false;
  }

  // 打开「我的中奖」，重置分页并拉取第一页
  openMyPrize() {
    this.records = [];
    this.prizePage = 0;
    this.prizeFinished = false;
    this.prizeLoadingPage = 0;
    this.prizeLoading = true;
    this.myPrizeVisible = true;
    this.onPrizeLoad();
  }

  // 中奖列表下拉（滚动到底部）加载下一页
  async onPrizeLoad() {
    if (this.prizeFinished) return;
    const page = this.prizePage + 1;
    // 该页正在请求中，直接忽略（van-list 触发 load 时 prizeLoading 已为 true）
    if (page === this.prizeLoadingPage) return;
    this.prizeLoadingPage = page;
    this.prizeLoading = true;
    const unionid = localStorage.getItem('unionid');
    try {
      const res: any = await getPrizeList(page, unionid);
      if (!res || res.code !== 200) {
        this.prizeFinished = true;
        if (page === 1) this.records = [];
        return;
      }
      const list: PrizeRecord[] = (res.data || []).map((item: any) => ({
        id: Number(item.id) || 0,
        date: this.formatDate(
          this.toDate(item.created_at || item.created_date),
        ),
        // 实物取奖品名，积分取卡券描述
        name: item.prize_name || item.prize_card || '',
        workType: readWorkType(item),
        needAddress: isPhysicalPrize(readWorkType(item)) && !!item.need_address,
        address: item.address || undefined,
      }));
      // 去重，避免接口翻页异常导致重复数据
      const appended = page > 1 ? this.filterRepeat(list) : list;
      this.records = page > 1 ? this.records.concat(appended) : list;
      this.prizePage = page;
      // 返回数据不足一页或全部重复，视为已加载完
      if (list.length < PRIZE_PAGE_SIZE || appended.length === 0) {
        this.prizeFinished = true;
      }
    } catch (e) {
      this.prizeFinished = true;
      if (page === 1) this.records = [];
    } finally {
      if (this.prizeLoadingPage === page) this.prizeLoadingPage = 0;
      this.prizeLoading = false;
    }
  }

  // 过滤掉已存在（同 id）的中奖记录
  private filterRepeat(list: PrizeRecord[]): PrizeRecord[] {
    const ids = this.records
      .filter((item) => item.id)
      .map((item) => item.id as number);
    return list.filter((item) => !item.id || ids.indexOf(item.id) === -1);
  }

  // 点击列表的「填写/修改地址」：先用已有数据回填，再拉详情覆盖
  onFillAddress(record: PrizeRecord) {
    this.editingRecord = record;
    this.addressTitle = `恭喜您抽中${record.name}`;
    this.addressForm = { name: '', address: record.address || '' };
    this.addressVisible = true;
    if (record.id) this.loadPrizeDetail(record.id);
  }

  // 中奖记录详情（prize-detail），回填已填写的收货信息
  async loadPrizeDetail(id: number) {
    const record = this.editingRecord;
    const unionid = localStorage.getItem('unionid');
    try {
      const res: any = await getPrizeDetail(id, unionid);
      const detail = res && res.code === 200 ? res.data || {} : null;
      if (!detail) return;
      const name = detail.name || detail.username || detail.receiver || '';
      const address = detail.address || '';
      const detailPhone = detail.phone || detail.mobile || '';
      this.addressForm = { name, address };
      // 详情返回的手机号作为提交时的收货手机号
      if (detailPhone) this.phone = String(detailPhone);
      if (record) {
        record.address = address;
        record.needAddress = false;
      }
    } catch (e) {
      // 详情拉取失败不影响手动填写
    }
  }

  async onAddressConfirm(info: AddressInfo) {
    const { name, address } = info || ({} as AddressInfo);
    const record = this.editingRecord;
    this.addressVisible = false;
    if (!record) return;
    const ok = await this.submitAddress({ name, address }, record.id);
    if (ok) {
      record.address = address;
      record.needAddress = false;
    }
  }

  // 接口时间为时间戳或字符串，统一转成 Date
  private toDate(val: any): Date {
    const num = Number(val);
    if (!isNaN(num) && num > 0) {
      return new Date(num < 1e12 ? num * 1000 : num);
    }
    const date = new Date(String(val || '').replace(/-/g, '/'));
    return isNaN(date.getTime()) ? new Date() : date;
  }

  private formatDate(date: Date) {
    const p = (n: number) => `${n}`.padStart(2, '0');
    return `${date.getFullYear()}.${p(date.getMonth() + 1)}.${p(
      date.getDate(),
    )}`;
  }
}
